import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-weare',
  templateUrl: './weare.component.html',
  styleUrls: ['./weare.component.scss']
})
export class WeareComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
